<template>
  <div>
    <Menu></Menu>
    <div class="admin-container">
      <div class="left-sidebar">
        <div class="left-sidebar__header">
          <img src="/static/img/pictos/commande.svg" class="">
          <span>Groupes</span>
        </div>
      </div>
      <div class="content-area">
        <h1>Groupe : {{ detail[config.title_field] }}</h1>
        <backlink/>
        <b-container fluid>
          <b-row>
            <b-col>
              <div class="ibox">
                <div class="ibox-content">
                  <b-row>
                    <b-col>
                      <b-button
                        v-if="config.export_pdf"
                        class="float-right"
                        size="xs"
                        variant="white"
                        @click="$root.exportPdf(exportPdfData)"
                      >PDF</b-button>
                      <b-button
                        class="float-right"
                        size="xs"
                        variant="white"
                        :to="{name: config.edit_route_name, params:{id:detail.id}}"
                      >Editer</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <dl v-for="field in fields" class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                          <dt>{{ $t(field.label) | capitalize }}:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">
                            <router-link
                              v-if="field.detailLink && detail[field.name]"
                              :to="{name: field.detailLink, params:{id:detail[field.name].id}}"
                            >{{ field.formatter ? field.formatter(context, detail[field.name]) : detail[field.name] }}</router-link>
                            <template
                              v-else
                            >{{ field.formatter ? field.formatter(context, detail[field.name]) : detail[field.name] }}</template>
                          </dd>
                        </div>
                      </dl>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <template>
                <div>
                  <b-table striped hover :fields="fieldsFamilies" :items="detail['families']" />
                </div>
              </template>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
import Menu from "@/components/Global/Menu";

export default {
  name: "AdminImputationDetail",
  data() {
    return {
      config: config,
      detail: {},
      fields: {},
      context: this
    };
  },
  components: {
    Menu
  },
  computed: {
    exportPdfData: function() {
      let exportPdfData = {
        title: this.detail[config.title_field],
        infos: []
      };
      config.fields
        .filter(field => field.inPdfExport == true)
        .forEach(field => {
          exportPdfData.infos.push([
            field.label + " :",
            field.formatter
              ? field.formatter(this, this.detail[field.name])
              : this.detail[field.name] || null
          ]);
        });
      return exportPdfData;
    }
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    this.fields = config.fields.filter(field => field.inDetail == true);
    config.fields
      .filter(field => field.inDetail == true)
      .forEach(field => {
        this.detail[field.name] = null;
      });

    this.$store.dispatch(config.store_namespace + "/getAll").then(() => {
      this.detail = this.$store.getters[config.store_namespace + "/getItem"](
        this.$route.params.id
      );
    });
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .admin-container{ display: flex; margin-top: 0;
    nav{ height: 75px; }
  }
  .left-sidebar{ width: 300px;
    &__header{ background-color: $vert; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 100px; margin-left: 35px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
  }
  .container-fluid{ padding: 0; }
  .content-area{ width: calc(100% - 300px); padding: 40px 7%; margin-top: 0;
    h1{ font-family: 'ClanFFBlack'; color: $vert; font-size: 25px; margin-bottom: 20px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $vert; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .orders__list{ overflow: auto; height: 500px; padding-right: 20px; }
    &--mobile{ width: 100%; padding: 0; margin-top: 0;
      .orders__list{ height: auto; padding: 0; }
    }
  }
  .filters{ display: flex; margin-bottom: 50px;
    .filter{ height: 35px; line-height: 35px;  border: 1px solid $color1; }
    input[type=text]{ margin-left: 10px; width: auto; flex: 1; padding: 0 15px; font-size: 12px; }
    select{ width: 150px; font-size: 12px; }
  }
  dt{ color: $color1; font-size: 13px; font-family: 'ClanProBold'; }
  dd{ font-size: 13px; font-family: 'ClanPro'; }
</style>



// WEBPACK FOOTER //
// src/components/Imputation/AdminImputationDetail.vue